import React, { useEffect, useState } from "react"
//GRAPHQL
import { useQuery } from "@apollo/client"

// MUI AND DIV COMPONENTS
import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { IconButton, Paper, } from "@mui/material"
import { Folder } from "@mui/icons-material"

// QUERIES, MUTATIONS, CONTEXT, HOOKS
import { GET_COMPANIES } from "../../../queries"
import SubscriptionCell from "./SubscriptionCell"
import { FetchMoreCallbackArgs, TablePaginated, TableToolBarStacked } from "ui"
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "name", headerName: "Name", flex: 1, sortable: true, resizable: false, editable: false, disableColumnMenu: true,
        renderCell(params) {
            return (<div>{params.row.name}</div>)
        }
    },
    { field: "type", headerName: "Company Type", flex: .5, sortable: true, resizable: false, editable: false, disableColumnMenu: true, }
]

const mapeEdgesToTable = (data: any) => {
    return {
        ...data.node
    }
}

interface CompanyTableProps {
    handleSelectedCompany: (value: any) => void
}
const DEFAULT_PAGE_SIZE = 2
export const CompanyTable = ({ handleSelectedCompany }: CompanyTableProps) => {
    const { loading, data, fetchMore } = useQuery(GET_COMPANIES, {
        notifyOnNetworkStatusChange: true,
        variables: {
            query: "",
            first: DEFAULT_PAGE_SIZE
        }
    })
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[];
        filteredRows: GridRowModel[];
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })

    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS];
            columns.push({
                field: "subscriptions", headerName: "Subscriptions", flex: 2, sortable: true, resizable: false, editable: false, disableColumnMenu: true,
                align: "center", headerAlign: "center",
                renderCell: (params) => {
                    const _subs = params.row.companySubscriptions
                    return (<SubscriptionCell subs={_subs} />)

                }
            })
            columns.push({
                field: "details", headerName: "Company File", width: 100, headerAlign: "center", sortable: false, align: "center", resizable: false, editable: false, disableColumnMenu: true,
                renderHeader: () => {
                    return <div style={{ whiteSpace: "break-spaces", fontWeight: 500, lineHeight: 1, justifyContent: "center", textAlign: "center" }}>
                        Company File
                    </div>
                },
                renderCell: (params) => {
                    const onClick = () => {
                        handleSelectedCompany(params.row)
                    }
                    return <IconButton onClick={onClick}>
                        <Folder />
                    </IconButton>
                }
            })
            const rows = data?.companies?.edges?.map(mapeEdgesToTable) ?? [];
            return {
                ...prevState,
                columns,
                filteredRows: [],
                rows
            }
        })
    }, [data, loading])
    const handleFilter = (selectionOption: String) => {
        setPageTableState((prevState) => {
            const filteredRows =
                selectionOption === "ACTIVE"
                    ? prevState.rows.filter((x) => !x.expired)
                    : prevState.rows
            return {
                ...prevState,
                status: selectionOption === "ALL" ? "NORMAL" : "FILTERING",
                filteredRows
            }
        })
    }

    const handleFetchMore = async (variables: FetchMoreCallbackArgs) => {
        await fetchMore({
            variables: {
                query: variables.query ?? "",
                after: variables.after ?? null,
                first: variables.first ?? DEFAULT_PAGE_SIZE,
            }
        }).then((res) => {
            const rows = res?.data?.companies?.edges?.map(mapeEdgesToTable) ?? [];
            if (pageTableState.status === "FILTERING") {
                //if its filtering we don't want to mess with this, but we also want to call new things if it updates
                setPageTableState((prevState) => ({
                    ...prevState,
                    rows,
                }));
            } else {
                setPageTableState((prevState) => ({
                    ...prevState,
                    filteredRows: [],
                    rows,
                }));
            }
        }).catch(err => {
            console.log("there is an error: ", err)
        })
    }

    return (
        <Paper>
            <TablePaginated
                loading={loading}
                rows={pageTableState.status === "FILTERING"
                    ? pageTableState.filteredRows
                    : pageTableState.rows
                }
                renderToolbar={({ onSearch, onSearchClear, searchQuery }) => (
                    <TableToolBarStacked
                        title='Companies'
                        searchQuery={searchQuery ?? ""}
                        onSearch={onSearch}
                        onSearchClear={onSearchClear}
                        onFilter={handleFilter}
                        filterTableName="standard"
                    />
                )}
                autoHeight
                pageInfo={data?.companies?.pageInfo}
                pageSize={DEFAULT_PAGE_SIZE}
                getRowClassName={(params) => params.row.companySubscriptions.length > 0 ? "Active" : "Expired"}
                disableBoxShadow
                columns={pageTableState.columns}
                totalRows={data?.companies?.totalCount ?? 0}
                onFetchMore={handleFetchMore}
            />
        </Paper>
    )
}